import { render, staticRenderFns } from "./IconFail.vue?vue&type=template&id=0f65a442&"
import script from "./IconFail.vue?vue&type=script&lang=js&"
export * from "./IconFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports